// extracted by mini-css-extract-plugin
export default {"returnItemInstructionTitle":"xW-z","upsLogoAndTitle":"yW-z","privateLabelHeader":"zW-z"};